export default defineNuxtRouteMiddleware(async (to, from) => {
  const { $site } = useNuxtApp();

  const allowNewRegistrations = $site.settings.allowNewRegistrations

  if (!allowNewRegistrations) {
    return navigateTo('/')
  }
})